package com.bulut.mecitogullari.core.platform

import kotlinx.browser.window

actual val isPrintSupported: Boolean = true

actual fun printHtml(html: String, fileName: String) {
    val popup = window.open("", "_blank") ?: return
    popup.document.write(html)
    popup.document.close()
}
